import { DefaultService } from '@/services/DefaultService';

export default class RamoService extends DefaultService {
	constructor(http, router, env) {
		super(http, router, env);
	}

	findAllCombo(limit = 50, ...param) {
		return this._http
			.get(encodeURI(`${this._env}/getcombo/ramo.json?limit=${limit}&param=${param}`), this._headers)
			.then((res) => { 
                return res.body; 
            }, (err) => {
                this.verifyError(err);
                throw new Error('Problems while jobs are loading');
			});
	}

	save(ramo) {
		return this._http.post(`${this._env}/ramo`, ramo, this._headers).then(res => {
			return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}
}
